<script setup>
import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="section-container">
    <div class="py-12">
      <h2 class="text-4xl md:text-5xl">{{ t('Flexibele oplossingen voor zzp\'ers') }}</h2>

      <!-- Pyramid Design -->

      <div class="flex items-center gap-8 mt-8 w-full">
        <!-- Pyramid -->
        <div class="pyramid text-center">
          <div class="pyramid__section">1</div>
          <div class="pyramid__section">2</div>
          <div class="pyramid__section">3</div>
        </div>

        <!-- Right Side Text -->
        <div class="flex flex-col justify-center text-left w-64">
          <div class="text-item mb-15">
            <h3 class="text-xl font-bold">Flexibiliteit</h3>
            <p
              class="mt-2"
            >Voldoende ruimte voor overleg m.b.t. wensen en mogelijkheden. U bepaalt zelf uw werktijden en uw tarieven.</p>
          </div>
          <div class="text-item mb-15">
            <h3 class="text-xl font-bold">Klantkeuze</h3>
            <p class="mt-2">U kiest zelf welke zorginstellingen u wilt bedienen</p>
          </div>
          <div class="text-item mb-15">
            <h3 class="text-xl font-bold">Zekerheid</h3>
            <p class="mt-2">Zorgblik zorgt voor een stroom aan interessante opdrachten.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.pyramid {
  width: 500px;
  display: flex;
  flex-direction: column;
  height: 500px;
  -webkit-clip-path: polygon(50% 0, 100% 100%, 0 100%);
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
}

.pyramid__section {
  flex: 1 1 100%;
  background-color: #dfece9;
  margin-bottom: 4px;
  border-color: #c7d4d0;
}
</style>
